import GeneralView from '~/generalView';
import Handlebars from 'handlebars';
import Settings from '~/settings.js';
import EventHub from '~/eventHub';
import profiles_template from '~/templates/profiles.handlebars';
import getReportSuperCategoryService from '~/services/reportCategoryService';
import getUtilsService from '~/services/utilsService';
import toastr from 'toastr';

var UseraddView = GeneralView.View.extend({
	tagName: "div",
	className: 'User',
	roleid: '',
	newRoleName: '',
	events: {
		'click #savenewrole':'saveRole',
		'change .profilescontainer': 'setprofilesoptions',
		'click #save-editprofile': 'savepremissions',
		'click .deleteprofile': 'deleteprofile',
		'change #accessallreportscheck': 'checkallcategories',
		//'change #readonlyreportscheck': 'changereadonlyreports',
		'click .show_data':'showEdit',
		'click .discard_changes_role':'discardChangesRole',
		'click .edit_role':'editRole',
		'change .permissioncheckbox': 'checkReadOnlyReports',
	},

	changereadonlyreports: function(e){
		// var checkedreadonlyreports = $("#readonlyreportscheck").is(':checked');
		// var elementsToChange = $("#changereportstatecheck, #asignreportscheck, #relocatereportscheck");
		// elementsToChange.prop('disabled', checkedreadonlyreports).prop('checked', false);
	},

	checkReadOnlyReports: function(e){
		var obj = e.currentTarget;
		var permissions = getUtilsService.getprofilepermissions();
		if(permissions.readonlyreports){	
			if(obj.id == 'accessallreportscheck'){
				if(obj.checked){
					$("#readonlyreportscheck").prop('disabled', true);
					$("#readonlyreportscheck").prop('checked', true);
				}
				else{
					$("#readonlyreportscheck").prop('disabled', false);
					$("#readonlyreportscheck").prop('checked', false);
				}
			}
			if(obj.id == 'reportscheck'){
				if(obj.checked){
					$("#readonlyreportscheck").prop('disabled', true);
					$("#readonlyreportscheck").prop('checked', true);
				}
				else{
					$("#readonlyreportscheck").prop('disabled', false);
					$("#readonlyreportscheck").prop('checked', false);
				}
			}
		}
	},

	checkallcategories: function(e){
		if ($("#accessallreportscheck").is(":checked")== true ) {
			$('.categoriescheckbox').prop('checked', true);
			$('.categoriescheckbox').attr('disabled',true);
			$('.admincategoriescheckbox').attr('disabled',true);
			$('.admincategoriescheckbox').prop('checked',true);
		}
		else{
			$('.categoriescheckbox').prop('checked', false);
			$('.categoriescheckbox').attr('disabled',false);
			$('.admincategoriescheckbox').attr('disabled',false);
			$('.admincategoriescheckbox').prop('checked',false);
		}
	},

	savepremissions: function(){
		var reportscheck = $("#reportscheck").is(":checked");
		var usercheck = false;
		var addusercheck = $("#addusercheck").is(":checked");
		var consultcheck = $("#consultcheck").is(":checked");
		var profilecheck = $("#profilecheck").is(":checked");
		if(addusercheck || consultcheck || profilecheck){
			usercheck = true;
		} 
		var edituserscheck = $("#editusercheck").is(":checked");
		var admincategoriescheck = $("#admincategoriescheck").is(":checked");
		var notificationscheck = $("#notificationscheck").is(":checked");
		var reportchartscheck = $("#reportchartscheck").is(":checked");
		var userchartscheck = $("#userchartscheck").is(":checked");
		var newscheck = $("#newscheck").is(":checked");
		var accessallreportscheck = $("#accessallreportscheck").is(":checked");
		var trazabilidadusercheck = $("#trazabilidadusercheck").is(":checked");
		var trazabilidadreportcheck = $("#trazabilidadreportcheck").is(":checked");
		var readonlyreportscheck = $("#readonlyreportscheck").is(":checked");
		var editmyprofilecheck = $("#editmyprofilecheck").is(":checked");
		var changereportstatecheck = $("#changereportstatecheck").is(":checked");
		var asignreportscheck = $("#asignreportscheck").is(":checked");
		var relocatereportscheck = $("#relocatereportscheck").is(":checked");
		var categories = []; 
		$("input:checkbox[name=categoriesprofiles]:checked").each(function(){
			categories.push($(this).val());
		});
		var permissions = {'reports': reportscheck, 'users': usercheck, 'addusers': addusercheck, 'consultusers': consultcheck, 'profiles': profilecheck, 'admincategories': admincategoriescheck, 'notifications': notificationscheck, 'reportcharts': reportchartscheck, 'usercharts': userchartscheck, 'news': newscheck, 'accessallreports' : accessallreportscheck, 'readonlyreports' : readonlyreportscheck, 'trazabilidaduser' : trazabilidadusercheck, 'trazabilidadreport' : trazabilidadreportcheck, 'categories':categories, 'editusers': edituserscheck, 'editmyprofile': editmyprofilecheck, 'changereportstate': changereportstatecheck,'asignreports': asignreportscheck, 'relocatereports': relocatereportscheck };
		var vid = this.roleid;
		var that = this;
		Parse.Cloud.run("editRole", {"id": vid, "permissions": permissions}).then(function(result) {
			toastr.success("Operación realizada");
			$('.permissioncheckbox').prop('checked', false);
			that.render();
			var user = Parse.User.current();
			if (result.attributes.name == user.attributes.role) {
				localStorage.setItem('permissions', JSON.stringify(result.attributes.permissions));
			}
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
				default:
					toastr.error(arrlang[lang]['RoleNotSaved'],"Error");
				break;
			}
			that.render();
		});
	},
	
	deleteprofile: function(){
		var that = this;
		toastr.options.timeOut = "0";
		toastr.options.extendedTimeOut = "0";
		var vid = this.roleid;
		var txt = '<span>'+ arrlang[lang]["DeleteRole"] +'</span><br><button class="btntoastr btnaccept" id="'+ vid +'">'+ arrlang[lang]["ToastrAccept"] +'</button><button class="btntoastr btncancel">'+ arrlang[lang]["ToastrCancel"] +'</button>';
		this.toastrButtons(txt, 'sucess');
		$('.btnaccept').one("click", function(e){
			that.acceptButtonDeleteRole(e);
		});
		$('.btncancel').one("click", function(){
			that.cancelButtonDeleteRole();
		});
	},
	
	acceptButtonDeleteRole: function(e){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		var vid = $(e.currentTarget).attr('id');
		var that = this;
		Parse.Cloud.run("deleteRole", {"id": vid}).then(function(result) {
			$('.permissioncheckbox').prop('checked', false);
			toastr.success("Operación realizada");
			that.render();
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
				default:
					if(arrlang[lang][error.message]){
						toastr.warning(arrlang[lang][error.message],"Aviso");
					}
				break;
			}
		});
	},
	
	cancelButtonDeleteRole: function(){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
	},

	setprofilesoptions: function(e){
		$('.permissioncheckbox').attr("disabled", false);
		$('.permissioncheckbox').prop('checked', false);
		var id = $('input[name=profilesradio]:checked').val();
		if(this.roleid != undefined){
			toastr.clear();
			toastr.options.timeOut = "5000";
			toastr.options.extendedTimeOut = "1000";
			var roleName = $('#admin_profiles'+this.roleid).text();
			$('#input_role'+this.roleid).val(roleName);
			$('#deleteprofile-'+this.roleid).hide();
			$('#show_field_role'+this.roleid).hide();
			$('#edit_field_role'+this.roleid).hide();
			$('#admin_profiles'+this.roleid).show();
			$('.margin-fix-'+this.roleid).css('margin-left', '0%');
		}
		this.roleid = id;
		$('#deleteprofile-'+this.roleid).show();
		$('#show_field_role'+this.roleid).show();
		$('.margin-fix-'+this.roleid).css('margin-left', '-25.5%');
		var selectedrole;
		var vrolename;
		var permissions = getUtilsService.getprofilepermissions();
		Parse.Cloud.run("getroles").then((roles) => {
			for (var i = 0; i <= roles.length - 1; i++) {
				if (roles[i].id == id) {
					selectedrole = roles[i].attributes.permissions;
					vrolename = roles[i].attributes.name;
				}
			}
			if (vrolename == 'Administrador General') {
				$('#accessallreportscheck').prop('checked', true);
				$('#accessallreportscheck').attr('disabled',true);
				this.checkallcategories();
			}
			$("#reportscheck").prop('disabled', !permissions.reports);
			$("#reportscheck").prop('checked', selectedrole.reports);
			$("#addusercheck").prop('disabled', !permissions.addusers);
			$("#addusercheck").prop('checked', selectedrole.addusers);
			$("#consultcheck").prop('disabled', !permissions.consultusers);
			$("#consultcheck").prop('checked', selectedrole.consultusers);
			$("#profilecheck").prop('', !permissions.profiles);
			$("#profilecheck").prop('checked', selectedrole.profiles);
			$("#notificationscheck").prop('disabled', !permissions.notifications);
			$("#notificationscheck").prop('checked', selectedrole.notifications);
			$("#reportchartscheck").prop('disabled', !permissions.reportcharts);
			$("#reportchartscheck").prop('checked', selectedrole.reportcharts);
			$("#userchartscheck").prop('disabled', !permissions.usercharts);
			$("#userchartscheck").prop('checked', selectedrole.usercharts);
			$("#newscheck").prop('disabled', !permissions.news);
			$("#newscheck").prop('checked', selectedrole.news);
			$("#accessallreportscheck").prop('disabled', !permissions.accessallreports);
			$("#accessallreportscheck").prop('checked', selectedrole.accessallreports); 
			$("#trazabilidadusercheck").prop('disabled', !permissions.trazabilidaduser); 
			$("#trazabilidadusercheck").prop('checked', selectedrole.trazabilidaduser);
			$("#trazabilidadreportcheck").prop('disabled', !permissions.trazabilidadreport);
			$("#trazabilidadreportcheck").prop('checked', selectedrole.trazabilidadreport);
			$("#readonlyreportscheck").prop('checked', selectedrole.readonlyreports);
			$("#editusercheck").prop('disabled', !permissions.editusers);
			$("#editusercheck").prop('checked', selectedrole.editusers);
			$("#editmyprofilecheck").prop('disabled', !permissions.editmyprofile);
			$("#editmyprofilecheck").prop('checked', selectedrole.editmyprofile);
			$("#changereportstatecheck").prop('checked', selectedrole.changereportstate);
			$("#asignreportscheck").prop('checked', selectedrole.asignreports);
			$("#relocatereportscheck").prop('checked', selectedrole.relocatereports);
			// if (selectedrole.readonlyreports) {      
			// 	$("#changereportstatecheck, #asignreportscheck, #relocatereportscheck").prop({
			// 		'disabled': true,
			// 		'checked': false
			// 	});
			// }	
			if(permissions.readonlyreports){
				if(selectedrole.reports){
					$("#reportscheck").prop('disabled', true);
				}
				if(selectedrole.accessallreports){
					$("#accessallreportscheck").prop('disabled', true);
				}
			}
			if (accessallreportscheck) {
				this.checkallcategories();
			}
			if (selectedrole.admincategories) {
				$("#admincategoriescheck").prop('checked', selectedrole.admincategories);
			}
			for (var i = 0; i < selectedrole.categories.length; i++) {
				var selectedroleid = '';
				$("input:checkbox[name=categoriesprofiles]").each(function(){
					if (selectedrole.categories[i] == $(this).val()) {
						selectedroleid = selectedrole.categories[i];
					}
				});
				$("input:checkbox[id="+selectedroleid+"]").prop('checked', true);
			}
			if(!selectedrole.accessallreports){
				$("input:checkbox[name=categoriesprofiles]").each(function(){
					var disabled = true;
					for (var i = 0; i < permissions.categories.length; i++) {
						if (permissions.categories[i] == $(this).val()) {
							disabled = false;
						}
					}
					$("input:checkbox[id="+$(this).val()+"]").prop('disabled', disabled);
				});
			}
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},

	saveRole: function(){
		var that = this;
		var name = this.$el.find('#newroleinput').val();
		var supercat = this.$el.find('#newrolesupercategory').val();
		Parse.Cloud.run("createRole", { 'name': name,'supercat': supercat }).then(function(result) {
			toastr.success(arrlang[lang]["RoleCreated"]);
			that.render();
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
				case 111:
					if(error.message = 'name is required.'){
						toastr.warning(arrlang[lang]['ValidRoleName'],'Aviso');
					}
					else{
						toastr.error(arrlang[lang]['RoleNameNotSaved'],"Error");
					}
				break;
				case 137:
					toastr.error(arrlang[lang]['SameNameRole'],'Error');
				break;
				default:
					toastr.error(arrlang[lang]['RoleNameNotSaved'],"Error");
				break;
			}
		});
	},

	render: function () {
		this.attachEvents();
		$('#myModal').hide();
		$('.modal-backdrop').hide();
		return this;
	},

	attachEvents: function() {
		var x = getUtilsService.getprofilepermissions();
		var handlebarsTemplate = Handlebars.template(profiles_template);
		this.$el.html(handlebarsTemplate());
		this.$el.find('.prfilescontainer').hide();
		this.translate();
		Parse.Cloud.run("getroles").then((roles) => {
			var superCategoryPromise = getReportSuperCategoryService().fetch({
				all: true,
				cache: false
			}).then(superCategories => {
				var handlebarsTemplate = Handlebars.template(profiles_template);
				this.$el.html(handlebarsTemplate({
					categories: superCategories.models,
					roles: roles,
				}));
				$('.profilesloader').hide();
				if (Settings.shogunmonitorapp && Parse.User.current().attributes.role == 'Administrador General') {
					$(".newroleforclient").show();
				}
				$('.permissioncheckbox').attr("disabled", true);
			},
			(error) => {
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
				}
			});
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},
	
	showEdit: function(e){
		$('#show_field_role'+this.roleid).fadeOut("fast");
		$('#admin_profiles'+this.roleid).fadeOut("fast");
		$('#edit_field_role'+this.roleid).show("fast");
	},
	
	discardChangesRole: function(e){
		var roleName = $('#admin_profiles'+this.roleid).text();
		$('#input_role'+this.roleid).val(roleName);
		$('#show_field_role'+this.roleid).show("fast");
		$('#admin_profiles'+this.roleid).show("fast");
		$('#edit_field_role'+this.roleid).fadeOut("fast");
		toastr.clear();
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
	},
	
	editRole: function(e){
		var newRoleName = $('#input_role'+this.roleid).val();
		if(newRoleName != ''){
			this.newRoleName = newRoleName;
			var that = this;
			toastr.options.timeOut = "0";
			toastr.options.extendedTimeOut = "0";
			var txt = '<span>'+ arrlang[lang]["ChangeRole"] +'</span><br><button class="btntoastr btnaccept">'+ arrlang[lang]["ToastrAccept"] +'</button><button class="btntoastr btncancel">'+ arrlang[lang]["ToastrCancel"] +'</button>';
			this.toastrButtons(txt, 'sucess');
			$('.btnaccept').one("click", function(e){
				that.acceptButtonEditRole(e);
			});
			$('.btncancel').one("click", function(){
				that.cancelButtonEditRole();
			});
		}
		else{
			toastr.warning(arrlang[lang]['ValidRoleName'],'Error al editar perfil');
		}
	},
	
	acceptButtonEditRole: function(e){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		var that = this;
		Parse.Cloud.run("editRoleName", { 'id': this.roleid,'newRoleName': this.newRoleName }).then(function(result) {
			that.render();
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
				case 111:
					if(error.message = 'name is required.'){
						toastr.warning(arrlang[lang]['ValidRoleName'],'Aviso');
					}
					else{
						toastr.error(arrlang[lang]['RoleNameNotSaved'],"Error");
					}
				break;
				case 137:
					toastr.error(arrlang[lang]['SameNameRole'],'Error');
				break;
				default:
					toastr.error(arrlang[lang]['RoleNameNotSaved'],"Error");
				break;
			}
		});
	},
	
	cancelButtonEditRole: function(){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
	},
});
/**
 *
 * Module profileView
 * @module views/profileView
 * @returns ParseService
 */
export default UseraddView;
